import React from "react"
import styled from "styled-components"

const InputWrapper = styled.div`
  font-size: ${(props) => props.theme.fontSize};
  margin-bottom: 15px;
  padding-top: 10px;
  width: 100%;
`

const StyledLabel = styled.label`
  display: block;
  font-size: 0.75em;
  margin-bottom: 0.5em;
`

const StyledTextArea = styled.textarea`
  display: block;
  border-radius: 2px;
  appearance: none;
  border: 1px solid #888;
  padding: 0.5em 1em;
  font-size: 1em;
  width: 100%;
  box-sizing: border-box;
  word-wrap: break-word;
  min-height: 100px;
  resize: none;
`

const ErrorMessage = styled.div`
  position: absolute;
  color: ${(props) => props.theme.error};
  font-size: 0.75em;
  margin: 0.5em 0;
`

const InputTextArea = ({
  labelText,
  fieldName,
  placeholder,
  errorMessage,
  value,
  onChange,
  onBlur,
  disabled = false,
}: {
  labelText: string
  fieldName: string
  placeholder?: string
  type: "textarea"
  errorMessage?: string
  value: string
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  onBlur: (event: React.FocusEvent<HTMLTextAreaElement>) => void
  disabled?: boolean
}) => {
  return (
    <InputWrapper>
      <StyledLabel htmlFor={fieldName}>{labelText}</StyledLabel>
      <StyledTextArea
        data-testid="inputField"
        id={fieldName}
        // type={type}
        placeholder={placeholder}
        name={fieldName}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
      />
      <ErrorMessage>{errorMessage}</ErrorMessage>
    </InputWrapper>
  )
}

export default InputTextArea
